export default {
    url: '/edit/:id',
    template: '<manage-permissions-sites-edit tree="vm.tree" site="vm.site"/>',
    resolve: {
        site (SiteResource, $stateParams) {
            return SiteResource.get({ id: $stateParams.id }).$promise;
        },
        tree (SiteResource) {
            return SiteResource.indexTree().$promise;
        }
    },
    controller (site, tree) {
        this.site = site;
        this.tree = tree;
        this.site.isActive = true; // tmp init of status here until it is figured out in analyse
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/permissions/sites/edit/index.js